/* Enhances the article's three semantic data widgets into the reference's
   card treatment. The markup stays semantic in the source; everything here
   is additive so the article still reads correctly without JS. */
(function () {
  const PALETTE = ['#2f8f72', '#ddaf3a', '#c2703b', '#1f2937'];

  // "Roughly 15 to 20 percent improvement" -> [15, 20]; "single-digit" -> null
  function range(text) {
    const m = text.match(/(\d+(?:\.\d+)?)\s*(?:to|-|–)\s*(\d+(?:\.\d+)?)\s*percent/i);
    if (m) return [parseFloat(m[1]), parseFloat(m[2])];
    const one = text.match(/(\d+(?:\.\d+)?)\s*percent/i);
    return one ? [parseFloat(one[1]), parseFloat(one[1])] : null;
  }

  function chart(root) {
    const max = 40; // headroom above the largest stated range
    root.querySelectorAll('tbody tr').forEach(tr => {
      const cell = tr.cells[1];
      if (!cell || cell.querySelector('.up-w-track')) return;
      const text = cell.textContent.trim();
      const r = range(text);
      const down = /reduction|reduced|lower/i.test(text);
      cell.textContent = '';
      if (r) {
        const track = document.createElement('div');
        track.className = 'up-w-track';
        const band = document.createElement('span');
        band.className = 'up-w-band' + (down ? ' up-w-band--down' : '');
        band.style.left = Math.min(r[0] / max * 100, 96) + '%';
        band.style.width = Math.max((r[1] - r[0]) / max * 100, 4) + '%';
        track.appendChild(band);
        cell.appendChild(track);
      }
      const label = document.createElement('span');
      label.className = 'up-w-value';
      label.textContent = text;
      cell.appendChild(label);
    });
  }

  function compare(root) {
    if (root.querySelector('.up-w-cards')) return;
    const wrap = document.createElement('div');
    wrap.className = 'up-w-cards';
    const heads = [...root.querySelectorAll('h3')];
    heads.forEach(h => {
      const list = h.nextElementSibling;
      if (!list || list.tagName !== 'UL') return;
      const card = document.createElement('div');
      card.className = 'up-w-card';
      card.appendChild(h);
      list.querySelectorAll('li').forEach(li => {
        const lead = li.querySelector('strong');
        const kind = lead && /con/i.test(lead.textContent) ? 'con' : 'pro';
        li.dataset.kind = kind;
      });
      card.appendChild(list);
      wrap.appendChild(card);
    });
    if (wrap.children.length) root.appendChild(wrap);
  }

  function timeline(root) {
    const list = root.querySelector('ol');
    if (!list || root.querySelector('.up-w-phases')) return;
    const items = [...list.querySelectorAll('li')];
    const bar = document.createElement('div');
    bar.className = 'up-w-phases';
    items.forEach((li, i) => {
      const lead = li.querySelector('strong');
      if (!lead) return;
      // "Weeks 1-2, loading:" -> phase "Weeks 1-2", label "loading"
      const parts = lead.textContent.replace(/:\s*$/, '').split(',');
      const seg = document.createElement('span');
      seg.className = 'up-w-phase';
      seg.style.background = PALETTE[i % PALETTE.length];
      seg.textContent = (parts[1] || parts[0]).trim();
      bar.appendChild(seg);
      lead.textContent = parts[0].trim();
    });
    if (bar.children.length) list.parentNode.insertBefore(bar, list);
  }

  function note(root, text) {
    // The copy usually supplies its own closing caveat; only add one when it
    // does not, so the card never carries two footnotes.
    if (root.querySelector('.up-w-note')) return;
    if (root.querySelector(':scope > p')) return;
    const p = document.createElement('p');
    p.className = 'up-w-note';
    p.textContent = text;
    root.appendChild(p);
  }

  function boot() {
    document.querySelectorAll('.up-article [data-widget]').forEach(root => {
      if (root.dataset.upWidgetReady) return;
      root.dataset.upWidgetReady = '1';
      const kind = root.dataset.widget;
      if (kind === 'benefit-chart') { chart(root); note(root, 'Ranges reported in small clinical trials. Individual results vary.'); }
      if (kind === 'form-compare') { compare(root); note(root, 'Comparison based on commonly available product formats.'); }
      if (kind === 'dosage-timeline') { timeline(root); note(root, 'A general protocol, not a guaranteed outcome. Individual results vary.'); }
    });
  }

  document.addEventListener('DOMContentLoaded', boot);
  boot();
})();
